<template>
  <!-- <router-link
    :to="{ name: 'aihe', params: { topic_id: data.slug } }"
    tag="div"
    class="item card pointer px-4"
    :class="{ vib: data.vib }"
  > -->
  <div class="item card px-4 font-8-5">

    <!-- <img src="@/assets/cb_logo_grey.svg" alt="" title="Tämä dokumentti on..."> -->

    <div class="content">
      <div class="gallery-card-info mb-2">
        <router-link :to="{ name: 'aihe', params: { topic_id: data.slug } }" tag="h4" class="break-initial mb-3 txt-bold pointer">
          {{ data.title }}
          <i class="material-icons link font-11 color-grey-l1" style="transform: rotate(45deg);">link</i>
        </router-link>
        <!-- <h4 class="break-initial mb-1 txt-bold">{{ data.title }}</h4> -->
      </div>

      <div v-html="data.teaser" class="gallery-card-text text-content-html mb-2" style="font-size: 0.85rem;">
        <!-- <div v-html="data.teaser" class="text-content-html" style="font-size: 0.85rem;"></div> -->
      </div>

      <div v-if="data.author" class="color-grey font-8-5 i-block lheight-12">{{ data.author }}</div>

      <div class="h-1"></div> <!-- for visual reasons -->
    </div>

  </div>
  <!-- </router-link> -->

  <!-- <h1>otsikko</h1>
  <br><br>
  <p>tekstisisätlö <a href="">linkki</a></p>
  <h2>otsikko</h2>
  <ul>
    <li>itemi1</li>
    <li>itemi2</li>
    <li>itemi3</li>
  </ul> -->

</template>

<script>

export default {
  name: 'GitemTopics',

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      examples: []
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/styles.scss";

.card {
  img { display: none; }
  h4:hover { color: rgb(255, 187, 0); }
  &.vib {
    //background-color: color(ui-main) !important;
    //p { color: white !important; }
    img {
      display: inline-block;
      position: absolute;
      top: 8px;
      right: 8px;
      width: 12px;
      height: 12px;
    }
  }
}
</style>
